module.exports = __webpack_public_path__ + "media/images/redesign-images/design-gallery/design-gallery-bg-a545664375e682ea2d6e90c420bdb8db.jpg";